import { getPluralTranslation } from 'labels/lib/getPluralTranslation/getPluralTranslation'
import type { Labels, Plurals } from 'types/labels'

const DEFAULT_COUNT = 1

export const getTranslation = ({
	translations,
	key,
	locale,
	amount = DEFAULT_COUNT,
}: {
	translations: Labels | null
	key: string
	locale: string
	amount?: number
}): string => {
	if (!translations) {
		return key
	}

	if (!Object.keys(translations).includes(key)) {
		return key
	}

	if (typeof translations[key] === 'string') {
		return translations[key] as string
	}

	const pluralTranslation = getPluralTranslation({
		plurals: translations[key] as Plurals,
		count: amount,
		locale,
	})

	if (pluralTranslation === '') {
		return key
	}

	return pluralTranslation
}
